import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                menu: {
                    route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), '')}.home`,
                    text: 'Home',
                    icon: 'fas fa-home',
                },
                acl: {
                    view: 'TP_00001',
                },
            },
            settings: {
                menu: {
                    route: `${code}.settings`,
                    text: 'Configurações',
                    icon: 'fas fa-cogs',
                },
                acl: {
                    view                    : 'TP_00010',
                    edit                    : 'TP_00011',
                },
                url: {
                    getConfig               : `/${codeAPI}/gestao/definitions`,
                },
            },
            layers: {
                menu: {
                    route: `${code}.layers`,
                    text: 'Camadas',
                    icon: 'fas fa-layer-group',
                },
                acl: {
                    view                    : 'TP_00006',
                    detail                  : 'TP_00005',
                    add                     : 'TP_00003',
                    edit                    : 'TP_00004',
                    delete                  : 'TP_00007',
                    private                 : 'TP_00052',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/layers`,
                    getShow                 : `${codeAPI}/gestao/layers/:id`,
                    getCreate               : `${codeAPI}/gestao/layers`,
                    getUpdate               : `${codeAPI}/gestao/layers/:id`,
                    getDelete               : `${codeAPI}/gestao/layers/:id`,
                    getOGCLists             : '/backoffice/gestao/ogc/lists',
                    getLists                : `${codeAPI}/gestao/layers/lists`,
                    getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
                },
            },
            regulations: {
                menu: {
                    route: `${code}.regulations`,
                    text: 'Regulamentos',
                    icon: 'fas fa-book',
                },
                acl: {
                    view                    : 'TP_00015',
                    detail                  : 'TP_00014',
                    add                     : 'TP_00012',
                    edit                    : 'TP_00013',
                    delete                  : 'TP_00016',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/regulations`,
                    getShow                 : `${codeAPI}/gestao/regulations/:id`,
                    getCreate               : `${codeAPI}/gestao/regulations`,
                    getUpdate               : `${codeAPI}/gestao/regulations/:id`,
                    getDelete               : `${codeAPI}/gestao/regulations/:id`,
                    getLists                : `${codeAPI}/gestao/regulations/lists`,
                },
            },
            print_visible_emissions: {
                menu: {
                    route: `${code}.print_visible_emissions.config`,
                    text: 'print_visible_emissions.titles',
                    icon: 'fas fa-print',
                },
                acl: {
                    view                    : 'TP_00008',
                    config                  : 'TP_00008',
                    configEdit              : 'TP_00009',
                },
                url: {
                    getList                 : `/${codeAPI}/gestao/printvisible`,

                    getConfig               : `/${codeAPI}/gestao/printvisible/settings`,
                    getApps                 : `/${codeAPI}/gestao/printvisible/print/apps`,
                },
            },
            street_types: {
                menu: {
                    route: `${code}.street_types`,
                    text: 'Tipos Arruamento',
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'TP_00020',
                    detail                  : 'TP_00019',
                    add                     : 'TP_00017',
                    edit                    : 'TP_00018',
                    delete                  : 'TP_00021',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/streettypes`,
                    getShow                 : `${codeAPI}/gestao/streettypes/:id`,
                    getCreate               : `${codeAPI}/gestao/streettypes`,
                    getUpdate               : `${codeAPI}/gestao/streettypes/:id`,
                    getDelete               : `${codeAPI}/gestao/streettypes/:id`,
                },
            },
            street_state_types: {
                menu: {
                    route: `${code}.street_state_types`,
                    text: 'Estados Arruamento',
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'TP_00025',
                    detail                  : 'TP_00024',
                    add                     : 'TP_00022',
                    edit                    : 'TP_00023',
                    delete                  : 'TP_00026',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/streetstatetypes`,
                    getShow                 : `${codeAPI}/gestao/streetstatetypes/:id`,
                    getCreate               : `${codeAPI}/gestao/streetstatetypes`,
                    getUpdate               : `${codeAPI}/gestao/streetstatetypes/:id`,
                    getDelete               : `${codeAPI}/gestao/streetstatetypes/:id`,
                },
            },
            street_preposition_types: {
                menu: {
                    route: `${code}.street_preposition_types`,
                    text: 'Preposições Arruamento',
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'TP_00030',
                    detail                  : 'TP_00029',
                    add                     : 'TP_00027',
                    edit                    : 'TP_00028',
                    delete                  : 'TP_00031',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/streetprepositiontypes`,
                    getShow                 : `${codeAPI}/gestao/streetprepositiontypes/:id`,
                    getCreate               : `${codeAPI}/gestao/streetprepositiontypes`,
                    getUpdate               : `${codeAPI}/gestao/streetprepositiontypes/:id`,
                    getDelete               : `${codeAPI}/gestao/streetprepositiontypes/:id`,
                },
            },
            house_number_types: {
                menu: {
                    route: `${code}.house_number_types`,
                    text: 'Tipos Nº Polícia',
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'TP_00035',
                    detail                  : 'TP_00034',
                    add                     : 'TP_00032',
                    edit                    : 'TP_00033',
                    delete                  : 'TP_00036',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/housenumbertypes`,
                    getShow                 : `${codeAPI}/gestao/housenumbertypes/:id`,
                    getCreate               : `${codeAPI}/gestao/housenumbertypes`,
                    getUpdate               : `${codeAPI}/gestao/housenumbertypes/:id`,
                    getDelete               : `${codeAPI}/gestao/housenumbertypes/:id`,
                },
            },
            house_number_classification_types: {
                menu: {
                    route: `${code}.house_number_classification_types`,
                    text: 'Classificações Nº Polícia',
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'TP_00040',
                    detail                  : 'TP_00039',
                    add                     : 'TP_00037',
                    edit                    : 'TP_00038',
                    delete                  : 'TP_00041',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/housenumberclassificationtypes`,
                    getShow                 : `${codeAPI}/gestao/housenumberclassificationtypes/:id`,
                    getCreate               : `${codeAPI}/gestao/housenumberclassificationtypes`,
                    getUpdate               : `${codeAPI}/gestao/housenumberclassificationtypes/:id`,
                    getDelete               : `${codeAPI}/gestao/housenumberclassificationtypes/:id`,
                },
            },
        },
        tools: {

        },
    },
};

export default state;
